/* Eleonora Mantini — motion.js: l'UNICO file di movimento della bozza (ux/movimento.md).
   Cosa fa:
   - ingresso: il logo si lucida una volta per sessione, poi i titoli entrano per righe;
   - [data-righe]: titoli per righe, una volta sola, quando entrano nello schermo;
   - [data-rivela]: foto che si rivelano una volta (scala 1,06 → 1 e opacità);
   - .entra e .riga: blocchi e righe di bronzo che compaiono una volta;
   - card → scheda: dà il nome di View Transition alla foto cliccata (container transform);
   - .lucida: la lama di luce sul gioiello appena scelto e sul bottone «Aggiunto alla borsa»;
   - frase «Cerco…»: la parola scelta cambia con una dissolvenza morbida;
   - ?taratura: pannello Tweakpane per tarare durate e curve (solo bozza, approvato l'11/10).
   Cosa NON fa: nessuna animazione nel catalogo (zona di utilità), nessuno scroll dirottato.
   Costo: ~5 kB, nessuna libreria (Tweakpane solo con ?taratura).
   Lo stato nascosto lo mette lo script in testa (html.mov): senza JS o con «riduci movimento» tutto è già visibile. */
(function () {
  const html = document.documentElement;
  const muove = html.classList.contains('mov');
  const ms = nome => parseFloat(getComputedStyle(html).getPropertyValue(nome)) || 0;
  const esc = t => t.replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- la lucidatura: logo, oggetti, pagina ---------- */
  function lucida(el) {
    if (!el || !muove) return;
    el.classList.remove('ora'); void el.offsetWidth; el.classList.add('ora');
    setTimeout(() => el.classList.remove('ora'), ms('--dur-page') + 100);
  }
  document.querySelectorAll('.hdr .logo').forEach(l => {
    const g = document.createElement('span'); g.className = 'gloss'; g.setAttribute('aria-hidden', 'true');
    l.style.setProperty('--logo-maschera', 'url(' + (window.EM_ASSET || '') + 'logo-scuro.png)'); l.append(g);
  });
  const primaVolta = !sessionStorage.getItem('em-ingresso');
  sessionStorage.setItem('em-ingresso', '1');

  /* ---------- titoli per righe ---------- */
  function spezza(el) {
    const testo = el.textContent.replace(/\s+/g, ' ').trim();
    if (!testo) return;
    el.innerHTML = testo.split(' ').map(p => `<span class="r-p">${esc(p)}</span>`).join(' ');
    const righe = []; let alto = null;
    el.querySelectorAll('.r-p').forEach(s => { if (s.offsetTop !== alto) { righe.push([]); alto = s.offsetTop; } righe[righe.length - 1].push(s.textContent); });
    el.innerHTML = `<span class="vh">${esc(testo)}</span>` + righe.map((r, i) => `<span class="r-riga" aria-hidden="true"><span style="--i:${i}">${r.map(esc).join(' ')}</span></span>`).join('');
    el.dataset.testo = testo; el.dataset.righe = righe.length;
    el.classList.add('pronto');
  }
  function mostra(el) { el.classList.add('va'); }
  /* i titoli già entrati tornano testo semplice solo se cambia la larghezza (schermo ruotato):
     farlo a fine entrata ricalcolava l'impaginazione in mezzo allo scroll */
  let largo = innerWidth;
  addEventListener('resize', () => {
    if (innerWidth === largo) return; largo = innerWidth;
    document.querySelectorAll('[data-righe].va').forEach(el => { if (el.dataset.testo) el.textContent = el.dataset.testo; });
  });

  /* ---------- un solo osservatore per tutto ciò che entra una volta ---------- */
  const io = new IntersectionObserver(voci => voci.forEach(v => {
    if (!v.isIntersecting) return;
    const el = v.target; io.unobserve(el);
    if (el.matches('[data-righe]')) mostra(el); else el.classList.add('vista');
  }), { rootMargin: '0px 0px -12% 0px' });

  /* nel tema i gioielli e le tessere arrivano dopo il primo disegno: anche ciò che entra dopo si prepara, una volta sola */
  const tutti = (r, s) => [...(r.matches && r.matches(s) ? [r] : []), ...r.querySelectorAll(s)];
  function prepara(radice) {
    const r = radice || document;
    if (!muove) { tutti(r, '[data-righe]').forEach(el => el.classList.add('pronto')); return; }
    tutti(r, '[data-righe]:not(.pronto)').forEach(el => { spezza(el); io.observe(el); });
    tutti(r, '[data-rivela]:not(.vista),.entra:not(.vista),.riga:not(.vista)').forEach(el => io.observe(el));
  }
  /* le righe si misurano con il font vero, altrimenti gli a capo cambiano all'arrivo del font */
  (document.fonts ? document.fonts.ready : Promise.resolve()).then(() => {
    const eroe = document.querySelector('.schermo[data-video] [data-righe], main > section:first-child [data-righe]');
    if (eroe && muove) eroe.style.setProperty('--ritardo', primaVolta ? '350ms' : '120ms');
    prepara();
    new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType === 1) prepara(n); }))).observe(document.body, { childList: true, subtree: true });
    if (primaVolta) lucida(document.querySelector('.hdr .logo .gloss'));
  });

  /* ---------- card → scheda: la foto scelta diventa la foto del gioiello ---------- */
  document.addEventListener('click', e => {
    const a = e.target.closest('a.card');
    if (!a || e.ctrlKey || e.metaKey || e.shiftKey || e.button) return;
    const img = a.querySelector('.card-foto img'); if (img) img.style.viewTransitionName = 'foto-gioiello';
    sessionStorage.setItem('em-scelta', '1');
  });
  /* tornando indietro dalla bfcache il nome va tolto, o due foto avrebbero lo stesso nome */
  addEventListener('pageshow', e => { if (e.persisted) { document.querySelectorAll('.card-foto img').forEach(i => i.style.viewTransitionName = ''); html.classList.remove('passa'); } });

  /* sulla scheda: dopo l'arrivo la luce passa sul gioiello appena scelto */
  const primaFoto = document.querySelector('.galleria .foto');
  if (primaFoto && sessionStorage.getItem('em-scelta')) {
    sessionStorage.removeItem('em-scelta');
    primaFoto.classList.add('lucida');
    setTimeout(() => lucida(primaFoto), ms('--dur-large'));
  }
  window.EM_lucida = lucida;

  /* ---------- frase «Cerco…»: la parola cambia morbida ---------- */
  document.querySelectorAll('.frase select').forEach(s => s.addEventListener('change', () => {
    if (!muove || !s.animate) return;
    s.animate([{ opacity: 0.2, filter: 'blur(3px)' }, { opacity: 1, filter: 'blur(0)' }], { duration: ms('--dur-enter'), easing: getComputedStyle(html).getPropertyValue('--ease-out').trim() });
  }));

  /* ---------- pannello di taratura, solo bozza: ?taratura ---------- */
  if (new URLSearchParams(location.search).has('taratura')) {
    import('https://cdn.jsdelivr.net/npm/tweakpane@4.0.5/dist/tweakpane.min.js').then(({ Pane }) => {
      const p = new Pane({ title: 'Taratura del movimento' });
      const v = { lama: ms('--dur-page'), righe: ms('--dur-large'), stagger: ms('--stagger'), entrata: ms('--dur-enter') };
      const lega = (k, css, min, max) => p.addBinding(v, k, { min, max, step: 10 }).on('change', e => html.style.setProperty(css, e.value + 'ms'));
      lega('lama', '--dur-page', 300, 2500); lega('righe', '--dur-large', 200, 1500); lega('stagger', '--stagger', 0, 200); lega('entrata', '--dur-enter', 100, 1000);
      p.addButton({ title: 'Ripeti la lucidatura' }).on('click', () => { lucida(document.querySelector('.hdr .logo .gloss')); html.classList.remove('passa'); void html.offsetWidth; html.classList.add('passa'); setTimeout(() => html.classList.remove('passa'), v.lama + 100); });
    });
  }
})();
